<div *ngIf="components.length > 0 && !!components">

  <h3>Dazugehörige Teil-Komponenten:</h3>

  <clr-datagrid *ngIf="editpos === 0" [clrDgLoading]="loading">
    <clr-dg-column>Part</clr-dg-column>
    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
    <clr-dg-column>Anzahl</clr-dg-column>
    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'material'">Material</clr-dg-column>
    <clr-dg-column>Spezifikation (baugruppenspezifisch) </clr-dg-column>
    <clr-dg-column>Lager</clr-dg-column>
    <clr-dg-column></clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Component!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let component of components">
      <clr-dg-action-overflow>
        <button class="action-item"
                (click)="startEdit(component, false)"
        >Bearbeiten</button>
      </clr-dg-action-overflow>
      <clr-dg-cell>{{ component.position }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/component/details', component.technical_drawing ]">{{ component.technical_drawing }}</clr-dg-cell>
      <clr-dg-cell><span *ngIf="!component.technology">{{ component.number_of_subparts }}</span></clr-dg-cell>
      <clr-dg-cell [routerLink]="['/component/details', component.technical_drawing ]">{{ component.name }}</clr-dg-cell>
      <clr-dg-cell>{{ component.material }}</clr-dg-cell>
      <clr-dg-cell>{{ component.specification }}</clr-dg-cell>
      <clr-dg-cell><span *ngIf="!component.technology">{{ component.number_of_pieces_in_stock }}</span></clr-dg-cell>
      <clr-dg-cell>
        <button class="btn btn-danger btn-sm btn-icon" (click)="removeChild(componentID, component.technical_drawing, component.position)"><cds-icon shape="trash"></cds-icon></button>
      </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Komponenten pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{ components.length }} Komponente(n)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>

<ng-container *ngIf="editpos === 0">
  <h4>Teil-Komponente hinzufügen:</h4>

  <p><app-component-search [componentID]="componentID" [technology]="false.toString()" (submitParentNumber)="updateTable()"></app-component-search></p>

  <div *ngIf="technologies.length > 0">

    <h3>Angewandte Verfahren:</h3>

    <clr-datagrid *ngIf="editpos === 0" [clrDgLoading]="loading">
      <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
      <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
      <clr-dg-column style="max-width: 120px !important;"></clr-dg-column>
      <clr-dg-placeholder>We couldn't find any Component!</clr-dg-placeholder>
      <clr-dg-row *clrDgItems="let technologie of technologies">
        <clr-dg-action-overflow>
          <button class="action-item" (click)="removeChild(componentID, technologie.technical_drawing, technologie.position)">Löschen</button>
        </clr-dg-action-overflow>
        <clr-dg-cell [routerLink]="['/component/details', technologie.technical_drawing ]">{{ technologie.technical_drawing }}</clr-dg-cell>
        <clr-dg-cell [routerLink]="['/component/details', technologie.technical_drawing ]">{{ technologie.name }}</clr-dg-cell>
        <clr-dg-cell class="btn-group btn-primary btn-icon btn-sm" style="max-width: 120px !important;">
          <button class="btn" (click)="startEdit(technologie, true)">
            <cds-icon shape="pencil"></cds-icon>
          </button>
        </clr-dg-cell>
        <ng-container ngProjectAs="clr-dg-row-detail" *ngIf="technologie.specification">
          <clr-dg-row-detail *clrIfExpanded class="small">
            {{ technologie.specification }}
          </clr-dg-row-detail>
        </ng-container>

      </clr-dg-row>
      <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
          <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Komponenten pro Seite</clr-dg-page-size>
          {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
          von {{ components.length }} Komponente(n)
        </clr-dg-pagination>
      </clr-dg-footer>
    </clr-datagrid>
  </div>

  <h4>Verfahren hinzufügen:</h4>

  <p><app-component-search [componentID]="componentID" [technology]="true.toString()" (submitParentNumber)="updateTable()"></app-component-search></p>
</ng-container>

  <app-edit-specification *ngIf="editpos === 2" [editSpecificationsForm]="editSpecificationsForm" [technology]="editSpecificationsForm.get('technology')?.value === true"></app-edit-specification>
  <br />
  <div *ngIf="editpos === 2" class="btn-group">
    <button class="btn btn-outline" type="button" (click)="cancelEdit()">Abbrechen</button>
    <button class="btn btn-primary" type="submit" [disabled]="editSpecificationsForm.invalid" (click)="onSubmit()">Speichern</button>
  </div>


